import { Badge } from '../ui/badge';
import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { CreditCard } from 'lucide-react';
import { getStatusBadgeStyle } from './constants';

const SubscriptionsSection = ({ subscriptions }) => {
  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });
    } catch {
      return 'N/A';
    }
  };

  return (
    <AccordionItem value="subscriptions" className="bg-[#1E293B] border border-[#334155] rounded-lg overflow-hidden">
      <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-[#334155]/30" data-testid="subscriptions-trigger">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#F59E0B]/20 flex items-center justify-center">
            <CreditCard className="w-5 h-5 text-[#FBBF24]" />
          </div>
          <span className="text-lg font-semibold text-[#E2E8F0]" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Subscriptions
          </span>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-6 pb-4">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="border-b border-[#334155] hover:bg-transparent">
                <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Subscription Name</TableHead>
                <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Status</TableHead>
                <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Start Date</TableHead>
                <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Renews On</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {subscriptions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} className="text-center py-8 text-[#64748B]">
                    No subscriptions found.
                  </TableCell>
                </TableRow>
              ) : (
                subscriptions.map((sub, index) => (
                  <TableRow key={sub._id || sub.packCode || index} className="border-b border-[#334155]/50 hover:bg-[#334155]/20">
                    <TableCell className="text-[#E2E8F0] font-medium">
                      {sub.title || sub.packName || sub.packCode || 'N/A'}
                    </TableCell>
                    <TableCell>
                      <Badge variant="outline" className={`${getStatusBadgeStyle(sub.status)} border`}>
                        {sub.status || 'N/A'}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-[#94A3B8]">
                      {formatDate(sub.startDate)}
                    </TableCell>
                    <TableCell className="text-[#94A3B8]">
                      {formatDate(sub.nextRenewalDate)}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default SubscriptionsSection;
